module.exports = "https://cdn.realtymogul.com/static/media/press_logo_wsj.9c4c7701.jpg";